var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "asta-drawer",
      attrs: { app: "", fixed: "", temporary: "" },
      model: {
        value: _vm.drawer,
        callback: function ($$v) {
          _vm.drawer = $$v
        },
        expression: "drawer",
      },
    },
    [
      _c(
        "div",
        { staticClass: "drawer-header navy" },
        [
          _c(
            "v-avatar",
            { staticClass: "drawer-user-avatar", attrs: { size: "34" } },
            [
              _vm.user_pic
                ? _c("v-img", { attrs: { contain: "", src: _vm.user_pic } })
                : _c("v-icon", { attrs: { color: "white" } }, [
                    _vm._v("account_circle"),
                  ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "drawer-user-info" }, [
            _c("div", { staticClass: "drawer-user-name white--text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.user_displayName || _vm.user_uid) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "drawer-league-row secondary--text" },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "drawer-league-icon secondary--text",
                    attrs: { "x-small": "" },
                  },
                  [_vm._v("\n          security\n        ")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "drawer-league-name" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.asta_info.name) + "\n        "
                  ),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "white--text",
              attrs: { rounded: "", icon: "" },
              on: { click: _vm.toggle },
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      !_vm.admin && !_vm.my_squadra
        ? _c(
            "div",
            {
              staticClass: "error white--text pa-2 ma-2",
              staticStyle: { "border-radius": "3px" },
            },
            [
              _vm._v(
                "\n    Solo i presidenti delle squadre possono partecipare all'asta. I co-gestori\n    e gli ospiti non possono parteciparvi ma possono seguirne l'andamento.\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-list",
        { attrs: { dense: "" } },
        [
          !_vm.premium
            ? _c(
                "v-list-item",
                { attrs: { link: "" }, on: { click: _vm.promptSblocco } },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "orange" } }, [
                        _vm._v("workspace_premium"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [_vm._v("Asta Live senza limiti")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-subtitle",
                        { staticClass: "orange--text" },
                        [
                          _vm.asta_info.counter
                            ? _c("div", [
                                _vm._v("\n            Hai ancora "),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.asta_info.counter)),
                                ]),
                                _vm._v(" assegnazioni.\n          "),
                              ])
                            : _c("div", [_vm._v("Sblocca per continuare.")]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.my_squadra
            ? _c(
                "v-list-group",
                {
                  staticClass: "drawer-team-group",
                  attrs: { value: false },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function () {
                          return [
                            _c(
                              "v-list-item-icon",
                              [
                                _c("v-icon", { attrs: { color: "text" } }, [
                                  _vm._v("admin_panel_settings"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-item-content",
                              [
                                _c(
                                  "v-list-item-title",
                                  {
                                    staticClass:
                                      "drawer-team-title font-weight-bold",
                                  },
                                  [
                                    _vm._v(
                                      "\n            La mia squadra\n          "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-item-subtitle",
                                  { staticClass: "drawer-team-subtitle" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.mySquadraName) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3907541001
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    {
                      staticClass: "drawer-team-action",
                      attrs: { link: "" },
                      on: { click: _vm.gotoUser },
                    },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "v-list-item-title",
                            {
                              staticClass:
                                "drawer-team-action-title font-weight-bold",
                            },
                            [
                              _vm._v(
                                "\n            Modifica avatar\n            "
                              ),
                              _c(
                                "v-icon",
                                { attrs: { "x-small": "", color: "text" } },
                                [_vm._v("open_in_new")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "drawer-team-action-subtitle" },
                            [
                              _vm._v(
                                "\n            Poi clicca 'Modifica' per caricare foto\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-avatar",
                        { attrs: { size: "32" } },
                        [
                          _c("v-img", {
                            attrs: { contain: "", src: _vm.user_pic },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    {
                      staticClass: "drawer-team-action",
                      attrs: { link: "" },
                      on: { click: _vm.gotoNomeSquadra },
                    },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "v-list-item-title",
                            {
                              staticClass:
                                "drawer-team-action-title font-weight-bold",
                            },
                            [
                              _vm._v(
                                "\n            Modifica nome\n            "
                              ),
                              _c(
                                "v-icon",
                                { attrs: { "x-small": "", color: "text" } },
                                [_vm._v("open_in_new")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "drawer-team-action-subtitle" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.mySquadraName) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    {
                      staticClass: "drawer-team-action",
                      attrs: { link: "" },
                      on: { click: _vm.gotoGestoreSquadra },
                    },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "v-list-item-title",
                            {
                              staticClass:
                                "drawer-team-action-title font-weight-bold",
                            },
                            [
                              _vm._v(
                                "\n            Modifica presidente\n            "
                              ),
                              _c(
                                "v-icon",
                                { attrs: { "x-small": "", color: "text" } },
                                [_vm._v("open_in_new")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "drawer-team-action-subtitle" },
                            [
                              _vm._v(
                                "\n            Solo i presidenti giocano in Asta Live "
                              ),
                              _c("br"),
                              _vm._v("Non i cogestori\n          "),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    {
                      staticClass: "drawer-team-action",
                      attrs: { link: "" },
                      on: { click: _vm.showPlan },
                    },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "v-list-item-title",
                            {
                              staticClass:
                                "drawer-team-action-title font-weight-bold",
                            },
                            [
                              _vm._v(
                                "\n            Pianifica crediti\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.is_mobile
            ? _c(
                "v-list-item",
                {
                  staticClass: "drawer-save-assignments",
                  attrs: { link: "" },
                  on: { click: _vm.promptSaveRoseFromDrawer },
                },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { staticClass: "white--text" }, [
                        _vm._v("save"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold white--text" },
                        [_vm._v("Salva assegnazioni/rose")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.is_mobile && !_vm.Config.STANDALONE
            ? _c(
                "v-list-item",
                {
                  attrs: { link: "" },
                  on: { click: _vm.checkAllineamentoRoseFromDrawer },
                },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("sync"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [_vm._v("Riallineamento rose/crediti")]
                      ),
                      _vm._v(" "),
                      _c("v-list-item-subtitle", [
                        _vm._v(
                          "\n          Clicca per saperne di piú\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.my_squadra
            ? _c(
                "v-list-item",
                { attrs: { link: "" }, on: { click: _vm.promptDownloadRose } },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("download"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [_vm._v("Download Rose")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.my_squadra && !_vm.isAdminSet
            ? _c(
                "v-list-item",
                { attrs: { link: "" }, on: { click: _vm.promptChangeAdmin } },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("engineering"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [_vm._v("Nessun amministratore\n        ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "error--text" }, [
                        _vm._v("Imposta amministratore d'asta"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.my_squadra && _vm.isAdminSet
            ? _c(
                "v-list-item",
                { attrs: { link: "" }, on: { click: _vm.promptChangeAdmin } },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("engineering"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [_vm._v("Amministratore Asta\n        ")]
                      ),
                      _vm._v(" "),
                      _c("v-list-item-subtitle", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.adminUsername) +
                            "\n          "
                        ),
                        _c("div", {
                          staticClass: "stato",
                          class: _vm.adminPresenceClass,
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: {
                            "error--text":
                              _vm.adminPresence !=
                              _vm.Constants.PRESENCE_STATES.ONLINE,
                          },
                        },
                        [
                          _vm._v(
                            "\n          L'amministratore d'asta deve rimanere sempre online durante il corso\n          dell'asta o Asta Live si bloccherà.\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.my_squadra
            ? _c(
                "v-list-item",
                { attrs: { link: "" }, on: { click: _vm.promptStatiMercati } },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("outlined_flag"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [_vm._v("\n          Mercato Asta Live\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-subtitle",
                        {
                          staticClass: "font-weight-bold",
                          style: _vm.statoMercatoStyle,
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.statoMercatoText) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-list-item",
            { attrs: { link: "" }, on: { click: _vm.promptComeFunziona } },
            [
              _c(
                "v-list-item-icon",
                [
                  _c("v-icon", { attrs: { color: "text" } }, [
                    _vm._v("not_listed_location"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", { staticClass: "font-weight-bold" }, [
                    _vm._v("Come funziona?"),
                  ]),
                  _vm._v(" "),
                  _c("v-list-item-subtitle", {}, [
                    _vm._v("Guida veloce a Asta Live"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            { attrs: { link: "" } },
            [
              _c(
                "v-list-item-icon",
                [
                  _c("v-icon", { attrs: { color: "text" } }, [
                    _vm._v("support "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", { staticClass: "font-weight-bold" }, [
                    _c(
                      "a",
                      {
                        staticClass: "blue-grey--text text-decoration-none",
                        attrs: {
                          href: "https://www.facebook.com/groups/500245610367729/",
                          target: "_blank",
                        },
                      },
                      [_vm._v("Supporto")]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            {
              staticClass: "drawer-news-icon",
              attrs: { link: "" },
              on: { click: _vm.promptChangeLog },
            },
            [
              _c(
                "v-list-item-icon",
                [
                  _c("v-icon", { attrs: { color: "text" } }, [
                    _vm._v("new_releases"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", { staticClass: "font-weight-bold" }, [
                    _vm._v("\n          Novità Asta Live\n        "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.is_mobile
            ? _c(
                "v-list-item",
                { attrs: { link: "" }, on: { click: _vm.gotoAsta } },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", { attrs: { color: "text" } }, [
                        _vm._v("language"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "font-weight-bold" },
                        [
                          _vm._v("Web link\n          "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "text--text",
                              attrs: { "x-small": "", right: "" },
                            },
                            [_vm._v("open_in_new")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-item-subtitle", [
                        _vm._v("Asta Live è disponibile anche in"),
                        _c("br"),
                        _vm._v("\n          una più comoda versione desktop"),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "text--text text--lighten-2 text-decoration-underline",
                          },
                          [_vm._v(_vm._s(_vm.urlAsta))]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _vm.is_mobile
            ? _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:copy",
                      value: _vm.urlAsta,
                      expression: "urlAsta",
                      arg: "copy",
                    },
                  ],
                  attrs: { small: "", rounded: "", outlined: "" },
                },
                [_vm._v("\n      Copia link\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.classic && !_vm.Config.STANDALONE
        ? _c(
            "v-alert",
            {
              staticClass: "standalone-promo mx-2 my-2",
              attrs: { color: "cyan darken-3", dense: "", text: "" },
            },
            [
              _c(
                "div",
                { staticClass: "cyan--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "cyan" } },
                    [_vm._v("\n                  campaign\n                ")]
                  ),
                  _vm._v("\n                Asta Live è per tutti!"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm._v("\n        Vorresti usare Asta Live ma giochi con i "),
                  _c("b", [_vm._v("ruoli Mantra")]),
                  _vm._v("\n        o giocate su "),
                  _c("b", [_vm._v("altre piattaforme")]),
                  _vm._v("?"),
                  _c("br"),
                  _vm._v("Prova\n        "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "cyan lighten-1 white--text ml-1",
                      attrs: {
                        small: "",
                        depressed: "",
                        href: "https://asta-live.com",
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v("asta-live.com  "),
                      _c(
                        "v-icon",
                        {
                          staticClass: "ml-1",
                          attrs: { "x-small": "", color: "white" },
                        },
                        [_vm._v("open_in_new")]
                      ),
                    ],
                    1
                  ),
                  _vm._v("."),
                  _c("br"),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "version" }, [
        _c("small", [_vm._v(_vm._s(_vm.version))]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }